var inputTitleLess = {};
import genaration from '../../utils/classname';
export var inputTitleClass = genaration(inputTitleLess, 'input-title-box');